<!-- Overlay -->
<div *ngIf="open" class="fixed inset-0 z-[99999] flex items-center justify-center overflow-y-auto p-5" role="dialog"
  aria-modal="true" aria-labelledby="payment-options-title">

  <!-- Backdrop -->
  <div class="fixed inset-0 h-full w-full bg-gray-400/50 backdrop-blur-[2px]" (click)="onBackdropClick()"></div>

  <!-- Modal -->
  <div class="relative w-full max-w-4xl rounded-3xl bg-white p-6 lg:p-10 dark:bg-gray-900">

    <!-- Close btn -->
    <button type="button" (click)="onCancel()"
      class="absolute top-3 right-3 z-[999] flex h-9.5 w-9.5 items-center justify-center rounded-full bg-gray-100 text-gray-400 transition-colors hover:bg-gray-200 hover:text-gray-700 sm:top-6 sm:right-6 sm:h-11 sm:w-11 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
      aria-label="Cerrar">
      <svg class="fill-current" width="24" height="24" viewBox="0 0 24 24">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6.043 16.541c-.391.39-.391 1.023 0 1.414.39.39 1.023.39 1.414 0L12 13.414l4.543 4.542c.39.391 1.023.391 1.414 0 .39-.39.39-1.023 0-1.414L13.414 12l4.543-4.542c.39-.391.39-1.024 0-1.415-.391-.39-1.024-.39-1.414 0L12 10.586 7.457 6.043c-.39-.39-1.023-.39-1.414 0-.391.391-.391 1.024 0 1.415L10.586 12 6.043 16.541Z" />
      </svg>
    </button>

    <div class="w-full">
      <!-- Header -->
      <div class="mb-6 text-center">
        <h4 id="payment-options-title" class="text-2xl font-semibold text-gray-900 dark:text-white mb-2">
          Opciones de Pago
        </h4>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          Has seleccionado nuevas funcionalidades adicionales. Elige cómo deseas pagarlas:
        </p>
        <p class="text-xs text-gray-500 dark:text-gray-500 mt-1" *ngIf="getFeatureNames()">
          <strong>Funcionalidades:</strong> {{ getFeatureNames() }}
        </p>
      </div>

      <!-- Two Payment Options -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">

        <!-- Option 1: Current Month Only -->
        <div class="rounded-xl border-2 border-gray-200 dark:border-gray-700 p-6 hover:border-[#6C4DFF] transition-colors">
          <div class="mb-4">
            <h5 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Pagar solo este período
            </h5>
            <p class="text-sm text-gray-600 dark:text-gray-400">
              Paga el costo completo de las nuevas funcionalidades por el período actual (hasta la próxima fecha de facturación).
            </p>
          </div>

          <!-- Price Breakdown -->
          <div class="mb-4 space-y-2" *ngIf="currentMonthBreakdown">
            <div *ngFor="let item of currentMonthBreakdown.items" class="flex justify-between text-sm">
              <span class="text-gray-600 dark:text-gray-400">{{ item.label }}</span>
              <span class="font-medium text-gray-900 dark:text-white">
                {{ item.amount | currency:'COP':'symbol-narrow':'1.0-0' }}
              </span>
            </div>
            <div class="pt-2 border-t border-gray-200 dark:border-gray-700 flex justify-between">
              <span class="font-semibold text-gray-900 dark:text-white">Total</span>
              <span class="text-lg font-bold text-gray-900 dark:text-white">
                {{ currentMonthBreakdown.total | currency:'COP':'symbol-narrow':'1.0-0' }}
              </span>
            </div>
          </div>

          <!-- Fallback if no breakdown -->
          <div class="mb-4" *ngIf="!currentMonthBreakdown">
            <div class="text-right">
              <span class="text-2xl font-bold text-gray-900 dark:text-white">
                {{ currentMonthPrice | currency:'COP':'symbol-narrow':'1.0-0' }}
              </span>
            </div>
          </div>

          <!-- Button -->
          <button
            type="button"
            (click)="onSelectOption('current-month')"
            class="w-full rounded-lg bg-[#6C4DFF] hover:bg-[#5f44e6] text-white font-medium py-3 px-4 transition-colors shadow-[0_10px_25px_-10px_rgba(108,77,255,0.35)]">
            Pagar este mes
          </button>
        </div>

        <!-- Option 2: Current Month + Next Membership -->
        <div class="rounded-xl border-2 border-[#6C4DFF] bg-purple-50/30 dark:bg-purple-900/10 p-6 relative">
          <!-- Recommended Badge -->
          <span class="absolute top-3 right-3 inline-flex items-center rounded-full bg-[#6C4DFF] px-2.5 py-1 text-xs font-medium text-white z-10">
            Recomendado
          </span>

          <div class="mb-4 pr-20">
            <h5 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">
              Pagar este período + siguiente membresía
            </h5>
            <p class="text-sm text-gray-600 dark:text-gray-400">
              Paga el costo completo del período actual más el costo completo de las nuevas funcionalidades para el siguiente período de facturación.
            </p>
          </div>

          <!-- Price Breakdown -->
          <div class="mb-4 space-y-2" *ngIf="currentMonthBreakdown && nextMembershipBreakdown">
            <!-- Current Month Section -->
            <div class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">
              Este período (completo)
            </div>
            <div *ngFor="let item of currentMonthBreakdown.items" class="flex justify-between text-sm">
              <span class="text-gray-600 dark:text-gray-400">{{ item.label }}</span>
              <span class="font-medium text-gray-900 dark:text-white">
                {{ item.amount | currency:'COP':'symbol-narrow':'1.0-0' }}
              </span>
            </div>

            <!-- Next Membership Section -->
            <div class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1 mt-3 pt-2 border-t border-gray-200 dark:border-gray-700">
              Siguiente {{ billingCycle === 'monthly' ? 'mes' : 'año' }} (completo)
            </div>
            <div *ngFor="let item of nextMembershipBreakdown.items" class="flex justify-between text-sm">
              <span class="text-gray-600 dark:text-gray-400">{{ item.label }}</span>
              <span class="font-medium text-gray-900 dark:text-white">
                {{ item.amount | currency:'COP':'symbol-narrow':'1.0-0' }}
              </span>
            </div>
            <div class="pt-2 border-t border-gray-200 dark:border-gray-700 flex justify-between">
              <span class="font-semibold text-gray-900 dark:text-white">Total</span>
              <span class="text-lg font-bold text-gray-900 dark:text-white">
                {{ (currentMonthBreakdown.total + nextMembershipBreakdown.total) | currency:'COP':'symbol-narrow':'1.0-0' }}
              </span>
            </div>
          </div>

          <!-- Fallback if no breakdown -->
          <div class="mb-4" *ngIf="!currentMonthBreakdown || !nextMembershipBreakdown">
            <div class="text-right">
              <span class="text-2xl font-bold text-gray-900 dark:text-white">
                {{ currentMonthPlusNextPrice | currency:'COP':'symbol-narrow':'1.0-0' }}
              </span>
            </div>
          </div>

          <!-- Button -->
          <button
            type="button"
            (click)="onSelectOption('current-month-plus-next')"
            class="w-full rounded-lg bg-[#6C4DFF] hover:bg-[#5f44e6] text-white font-medium py-3 px-4 transition-colors shadow-[0_10px_25px_-10px_rgba(108,77,255,0.35)]">
            Pagar este mes + siguiente
          </button>
        </div>
      </div>

      <!-- Cancel Button -->
      <div class="text-center">
        <button
          type="button"
          (click)="onCancel()"
          class="text-sm text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

